import { render, staticRenderFns } from "./Camp.stags.vue?vue&type=template&id=27542349&scoped=true&lang=html&"
import script from "./Camp.stags.vue?vue&type=script&lang=js&"
export * from "./Camp.stags.vue?vue&type=script&lang=js&"
import style0 from "./Camp.stags.vue?vue&type=style&index=0&id=27542349&prod&lang=css&"
import style1 from "./Camp.stags.vue?vue&type=style&index=1&id=27542349&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27542349",
  null
  
)

export default component.exports